<button
    class="button {{customClass}}"
    (click)="onButtonClicked()"
    [ngClass]="{ active: isActive }"
    [disabled]="isActive || disabled"
    [innerHTML]="text"
></button>
